import { Input,Container } from './style';

export function InputDate({ type, active = true, ...rest }) {
    return (
        <Container>
            <Input type={type} active={active} {...rest} />
        </Container>
    )
}